'use strict';

class LintAlertController {
  constructor($scope,
              $filter,
              utils,
              DevicesService,
              ToastsService) {

    let $t = $filter('translate');
    let LintAlertConfig = {
      actualDuctLengthList: [
        {
          id: 'Less than 5\'',
          name: $t('properties.lint-alert.adl.values.less-than-5')
        }, {
          id: '5\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '5\'' })
        }, {
          id: '10\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '10\'' })
        }, {
          id: '15\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '15\'' })
        }, {
          id: '20\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '20\'' })
        }, {
          id: '25\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '25\'' })
        }, {
          id: '30\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '30\'' })
        }, {
          id: '35\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '35\'' })
        }, {
          id: '40\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '40\'' })
        }, {
          id: '45\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '45\'' })
        }, {
          id: '50\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '50\'' })
        }, {
          id: '55\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '55\'' })
        }, {
          id: '60\'',
          name: $t('properties.lint-alert.adl.values.text', { text: '60\'' })
        }, {
          id: 'More than 60\'',
          name: $t('properties.lint-alert.adl.values.more-than-60')
        }
      ],
      floors: function() {
        let vals = [];
        for (let i = 1; i <= 30; i++) {
          let val = $t('properties.lint-alert.floors.values.num', { num: i, unit: i % 10 });
          vals.push({
            id: val,
            name: val
          });
        }
        vals.push({
          id: 'Other',
          name: $t('properties.lint-alert.floors.values.other')
        });
        return vals;
      }(),
      numberOfElbowsList: function() {
        let vals = [];
        for (let i = 1; i <= 8; i++) {
          vals.push({ id: i, name: i });
        }
        return vals;
      }(),
      exteriorTerminationPoint: [
        {
          id: 'Side Wall Vent',
          name: $t('properties.lint-alert.etp.values.side-wall-vent')
        }, {
          id: 'Roof Vent',
          name: $t('properties.lint-alert.etp.values.roof-vent')
        }, {
          id: 'Soffit Vent',
          name: $t('properties.lint-alert.etp.values.soffit-vent')
        }, {
          id: 'Other Location',
          name: $t('properties.lint-alert.etp.values.other')
        }
      ],
      installedInLineBoosterFanList: [
        {
          id: 'No',
          name: $t('properties.lint-alert.bfi.values.No')
        }, {
          id: 'Yes',
          name: $t('properties.lint-alert.bfi.values.Yes')
        }
      ],
      stackableList: [
        {
          id: 'Stackable',
          name: $t('properties.lint-alert.stackable.values.stackable')
        }, {
          id: 'Side-by-side on Floor',
          name: $t('properties.lint-alert.stackable.values.floor')
        }, {
          id: 'Side-by-side on Pedestal',
          name: $t('properties.lint-alert.stackable.values.pedestal')
        }
      ],
      accessList: [
        {
          id: 'Easy to Access Dryer',
          name: $t('properties.lint-alert.access.values.easy')
        }, {
          id: 'Hard to Access Dryer',
          name: $t('properties.lint-alert.access.values.hard')
        }
      ],
      houseYearList: function() {
        let years = [];
        let now = new Date();
        for (let i = now.getFullYear(); i >= 1970; i--) {
          years.push({ id: i, name: i });
        }
        years.push({
          id: 'Before 1970',
          name: $t('properties.lint-alert.house-year.values.before-year', { year: 1970 })
        });
        return years;
      }(),
      applicationManufacturerList: [
        {
          id: 'General Electric',
          name: $t('properties.lint-alert.manufacturer.values.general-electric')
        }, {
          id: 'Whirlpool',
          name: $t('properties.lint-alert.manufacturer.values.Whirlpool')
        }, {
          id: 'LG',
          name: $t('properties.lint-alert.manufacturer.values.LG')
        }, {
          id: 'Miele',
          name: $t('properties.lint-alert.manufacturer.values.Miele')
        }, {
          id: 'Kenmore',
          name: $t('properties.lint-alert.manufacturer.values.Kenmore')
        }, {
          id: 'Samsung',
          name: $t('properties.lint-alert.manufacturer.values.Samsung')
        }, {
          id: 'Electrolux',
          name: $t('properties.lint-alert.manufacturer.values.Electrolux')
        }, {
          id: 'Bosch',
          name: $t('properties.lint-alert.manufacturer.values.Bosch')
        }, {
          id: 'Maytag',
          name: $t('properties.lint-alert.manufacturer.values.Maytag')
        }, {
          id: 'Frigidaire',
          name: $t('properties.lint-alert.manufacturer.values.Frigidaire')
        }, {
          id: 'Amana',
          name: $t('properties.lint-alert.manufacturer.values.Amana')
        }, {
          id: 'Other',
          name: $t('properties.lint-alert.manufacturer.values.Other')
        }
      ],
      transitionDuctMaterialList: [
        {
          id: 'Semi-Rigid (recommended)',
          name: $t('properties.lint-alert.tdm.values.semi-rigid')
        }, {
          id: 'DryerFlex (recommended)',
          name: $t('properties.lint-alert.tdm.values.dryer-flex')
        }, {
          id: 'Rigid Ductwork',
          name: $t('properties.lint-alert.tdm.values.rigid-ductwork')
        }, {
          id: '"Slinky" foil',
          name: $t('properties.lint-alert.tdm.values.slinky-foil')
        }, {
          id: 'White vinyl flex',
          name: $t('properties.lint-alert.tdm.values.white-vinyl-flex')
        }, {
          id: 'unknown',
          name: $t('properties.lint-alert.tdm.values.unknown')
        }
      ],
      applicationYearList: function() {
        let years = [];
        let now = new Date();
        for (let i = now.getFullYear(); i >= 1986; i--) {
          years.push({ id: i, name: i });
        }
        years.push({
          id: 'Older than 1986',
          name: $t('properties.lint-alert.application.values.older-than-year', { year: 1986 })
        });
        return years;
      }(),
      applicationPowerSourceList: [
        {
          id: $t('properties.lint-alert.ps.values.Electric'),
          name: $t('properties.lint-alert.ps.values.Electric')
        }, {
          id: $t('properties.lint-alert.ps.values.Electric'),
          name: $t('properties.lint-alert.ps.values.Natural-Gas')
        }, {
          id: $t('properties.lint-alert.ps.values.Electric'),
          name: $t('properties.lint-alert.ps.values.Propane')
        }
      ],

      getPropertiesList: function() {
        return {
          'actualDuctLengthList': this.actualDuctLengthList,
          'numberOfElbowsList': this.numberOfElbowsList,
          'exteriorTerminationPointList': this.exteriorTerminationPoint,
          'floorOfDryerLocationList': this.floors,
          'floorOfDryerTerminationPointList': this.floors,
          'installedInLineBoosterFanList': this.installedInLineBoosterFanList,
          'stackableList': this.stackableList,
          'accessList': this.accessList,
          'houseYearList': this.houseYearList,
          'applicationManufacturerList': this.applicationManufacturerList,
          'applicationYearList': this.applicationYearList,
          'applicationPowerSourceList': this.applicationPowerSourceList,
          'transitionDuctMaterialList': this.transitionDuctMaterialList
        };
      }
    };

    $scope.propertiesList = LintAlertConfig.getPropertiesList();

    function checkContentVal(val) {
      if (val == null || $.trim(val) == '') {
        return null;
      }
      return val;
    }

    function addProperty(arr, name, value) {
      if ($scope.properties.get(name).value == value) {
        return;
      } else {
        arr.push({ name: name, content: checkContentVal(value) });
      }
    }

    $scope.saveProperties = function() {
      let arr = [];
      addProperty(arr, 'actualDuctLength', $scope.adlId);
      addProperty(arr, 'numberOfElbows', $scope.elbow);
      addProperty(arr, 'exteriorTerminationPoint', $scope.etp);
      addProperty(arr, 'floorOfDryerLocation', $scope.dl);
      addProperty(arr, 'floorOfDryerTerminationPoint', $scope.dt);
      addProperty(arr, 'installedInLineBoosterFan', $scope.bfi);
      addProperty(arr, 'stackable', $scope.stackable);
      addProperty(arr, 'access', $scope.access);
      addProperty(arr, 'applicationManufacturer', $scope.manufacturer);
      addProperty(arr, 'applicationYear', $scope.applicationYear);
      addProperty(arr, 'applicationPowerSource', $scope.ps);
      addProperty(arr, 'houseYear', $scope.houseYear);
      addProperty(arr, 'transitionDuctMaterial', $scope.tdm);
      addProperty(arr, 'applicationModel', $scope.model);
      addProperty(arr, 'applicationSerialNumber', $scope.serial);
      addProperty(arr, 'applicationNotes', $scope.notes);
      if (arr.length === 0) {
        ToastsService.success(null, $t('common.nothing-changed'));
        return;
      }

      let properties = {
        property: arr
      };
      return DevicesService.setDeviceProperties($scope.device.id, $scope.device.locationId, properties)
        .then(function(data) {
          ToastsService.success();
          return data;
        });
    };

    $scope.$watch('ps', function() {
      console.info($scope.ps);
    });

    function getPropertyValByKey(properties, key) {
      if (properties == null || key == null) {
        return null;
      }
      let item = properties.get(key);
      if (item == null) {
        return null;
      }
      return item.value;
    }

    return DevicesService
      .getDeviceProperties($scope.device.id, { locationId: $scope.device.locationId })
      .then(function(data) {
        let properties = utils.array2Map(data.properties, 'name');
        $scope.properties = properties;
        $scope.adlId = getPropertyValByKey(properties, 'actualDuctLength');
        $scope.elbow = getPropertyValByKey(properties, 'numberOfElbows');
        $scope.etp = getPropertyValByKey(properties, 'exteriorTerminationPoint');
        $scope.dl = getPropertyValByKey(properties, 'floorOfDryerLocation');
        $scope.dt = getPropertyValByKey(properties, 'floorOfDryerTerminationPoint');
        $scope.bfi = getPropertyValByKey(properties, 'installedInLineBoosterFan');
        $scope.stackable = getPropertyValByKey(properties, 'stackable');
        $scope.access = getPropertyValByKey(properties, 'access');
        $scope.manufacturer = getPropertyValByKey(properties, 'applicationManufacturer');
        $scope.applicationYear = getPropertyValByKey(properties, 'applicationYear');
        $scope.ps = getPropertyValByKey(properties, 'applicationPowerSource');
        $scope.houseYear = getPropertyValByKey(properties, 'houseYear');
        $scope.tdm = getPropertyValByKey(properties, 'transitionDuctMaterial');
        $scope.model = getPropertyValByKey(properties, 'applicationModel');
        $scope.serial = getPropertyValByKey(properties, 'applicationSerialNumber');
        $scope.notes = getPropertyValByKey(properties, 'applicationNotes');
        return data;
      });
  }
}

export default angular
  .module('main.devices.lintalert.controller', [])
  .controller('LintAlertController', LintAlertController)
  .name;
